<template lang="pug">
.k-booking-join-button
  //- Join booking buttons
  template(v-if="showButton")
    k-button(
      v-if="!isPlatformiOS"
      x-small
      :href="booking.joinBookingLink"
    ).ma-0 Join now
    k-button(
      v-else
      color="brand-dark-blue"
      x-small
      :href="booking.joinBookingInApp"
      target="_blank"
    ).ml-0
      span Join booking in app
      k-icon(size="10" color="white").pl-2 apple
</template>

<script>
import { UAParser } from 'ua-parser-js'
export default {
  props: {
    booking: {
      required: true,
      type: Object
    },
  },
  data () {
    return {
      canJoinBooking: false,
      isPlatformiOS: false,
    }
  },
  computed: {
    showButton () {
      return this.canJoinBooking
    }
  },
  beforeDestroy () {
    clearInterval(this.counterInterval)
  },
  created () {
    this.canJoinBooking = this.booking.canJoinBooking
    if (!this.booking.hasStarted) {
      // refresh the countdown of upcoming booking
      this.tickUpcomingBookingTime()
    }
    const ua = new UAParser()
    this.isPlatformiOS = (ua.getOS().name === 'iOS') || (ua.getOS().name === 'Mac OS' && this.isTouchDevice())
  },
  methods: {
    isTouchDevice () {
      return (
        !!(typeof window !== 'undefined' &&
          ('ontouchstart' in window ||
            (window.DocumentTouch &&
              typeof document !== 'undefined' &&
              document instanceof window.DocumentTouch))) ||
        !!(typeof navigator !== 'undefined' &&
          (navigator.maxTouchPoints || navigator.msMaxTouchPoints))
      )
    },
    tickUpcomingBookingTime () {
      this.counterInterval = setInterval(() => {
        this.canJoinBooking = this.booking.canJoinBooking
        if (this.booking.hasStarted) {
          clearInterval(this.counterInterval)
        }
        // tick every 60 seconds
      }, 60000)
    },
  }
}
</script>
